'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CodeContainer = _react2['default'].createClass({
    displayName: 'CodeContainer',


    propTypes: {
        codeStringLines: _react2['default'].PropTypes.array.isRequired,
        classNames: _react2['default'].PropTypes.string
    },

    render: function render() {
        var lines = this.props.codeStringLines.join("\n").replace(/\&quot\;/g, '"');
        return _jsx('pre', {
            className: this.props.classNames
        }, void 0, lines);
    }
});

var CodeTabPaneWithResponse = _react2['default'].createClass({
    displayName: 'CodeTabPaneWithResponse',


    propTypes: {
        languageName: _react2['default'].PropTypes.string.isRequired,
        requestCodeStringLines: _react2['default'].PropTypes.array.isRequired,
        responseCodeStringLines: _react2['default'].PropTypes.array.isRequired,
        containerClassNames: _react2['default'].PropTypes.string,
        codeClassNames: _react2['default'].PropTypes.string,
        isCollapsed: _react2['default'].PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'containerClassNames': '',
            'codeClassNames': '',
            'isCollapsed': true
        };
    },

    getInitialState: function getInitialState() {
        return {
            isCollapsed: this.props.isCollapsed
        };
    },

    toggleResponse: function toggleResponse(evt) {
        evt.preventDefault();
        this.setState({
            'isCollapsed': !this.state.isCollapsed
        });
    },

    render: function render() {

        var classes = [(0, _classnames2['default'])({
            'm-code-example': true,
            'with-response': true,
            'is-collapsed': this.state.isCollapsed
        }), this.props.containerClassNames].join(' ');

        var reqClassNames = [(0, _classnames2['default'])({
            'm-code-example--code': true,
            'prettyprint': true
        }), this.props.codeClassNames].join(' ');

        var respClassNames = [(0, _classnames2['default'])({
            'm-code-example--code--json': true
        }), this.props.codeClassNames].join(' ');

        var request = _jsx(CodeContainer, {
            classNames: reqClassNames,
            codeStringLines: this.props.requestCodeStringLines
        });
        var response = '';

        // TODO: At some point, we'll want to create custom "response" examples
        // for each wrapper. For now, since the response is JSON, let's only display
        // this if the example is using cURL. -Chris (5/21/15)
        if (this.props.languageName === 'curl') {
            response = _jsx('div', {}, void 0, _jsx(CodeContainer, {
                classNames: respClassNames,
                codeStringLines: this.props.responseCodeStringLines
            }), _jsx('span', {
                className: 'm-code-example--expand-link',
                onClick: this.toggleResponse
            }, void 0, _jsx('span', {
                className: 'm-code-example--expand-link--dots'
            }, void 0, '...'), _jsx('a', {
                className: 'm-code-example--expand-link--link',
                href: '#'
            }, void 0, 'Show response')));
        }

        return _jsx('div', {
            className: classes
        }, void 0, request, response);
    }
});

module.exports = CodeTabPaneWithResponse;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/code-tab-pane-with-response.jsx
 ** module id = 733
 ** module chunks = 0
 **/